// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 699 ? "feature.fireworks" : chunkId) + "." + {"571":"0c9a1b1ec8476f6ce492","699":"343d027c0953dcbb249c"}[chunkId] + ".js";
};